import React from 'react';
import './PartnerStatsAdmin.css';

const PartnerStatsAdmin = ({ stats }) => {
    if (!stats) return null;

    const { resumen, ganancias_mensuales, partners_por_mes } = stats;

    // Calcular totales del año actual
    const totalGananciasAnuales = ganancias_mensuales.reduce((sum, item) => sum + item.total, 0);
    const totalPartnersAnuales = partners_por_mes.reduce((sum, item) => sum + item.cantidad, 0);

    return (
        <div className="partner-stats-admin">
            <h2>📊 Estadísticas Generales</h2>

            {/* Métricas principales */}
            <div className="stats-grid">
                <div className="stat-card stat-card--primary">
                    <div className="stat-icon">👥</div>
                    <div className="stat-content">
                        <h3>Partners Totales</h3>
                        <p className="stat-number">{resumen.total_partners.toLocaleString()}</p>
                    </div>
                </div>

                <div className="stat-card stat-card--success">
                    <div className="stat-icon">💰</div>
                    <div className="stat-content">
                        <h3>Ganancias Totales</h3>
                        <p className="stat-number">${resumen.total_ganancias.toLocaleString()}</p>
                    </div>
                </div>

                <div className="stat-card stat-card--info">
                    <div className="stat-icon">🔗</div>
                    <div className="stat-content">
                        <h3>Referidos Totales</h3>
                        <p className="stat-number">{resumen.total_referidos.toLocaleString()}</p>
                    </div>
                </div>

                <div className="stat-card stat-card--warning">
                    <div className="stat-icon">⏳</div>
                    <div className="stat-content">
                        <h3>Ganancias Pendientes</h3>
                        <p className="stat-number">{resumen.ganancias_pendientes.toLocaleString()}</p>
                    </div>
                </div>
            </div>

            {/* Métricas del año actual */}
            <div className="yearly-stats">
                <div className="yearly-stat">
                    <h4>📈 Ganancias Este Año</h4>
                    <p className="yearly-number">${totalGananciasAnuales.toLocaleString()}</p>
                </div>

                <div className="yearly-stat">
                    <h4>🆕 Nuevos Partners Este Año</h4>
                    <p className="yearly-number">{totalPartnersAnuales.toLocaleString()}</p>
                </div>
            </div>

            {/* Ganancias mensuales */}
            {ganancias_mensuales.length > 0 && (
                <div className="monthly-chart">
                    <h3>📊 Ganancias por Mes (Año Actual)</h3>
                    <div className="chart-container">
                        {ganancias_mensuales.map((item, index) => {
                            const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
                                'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
                            const maxValue = Math.max(...ganancias_mensuales.map(g => g.total));
                            const height = maxValue > 0 ? (item.total / maxValue) * 100 : 0;

                            return (
                                <div key={index} className="chart-bar">
                                    <div
                                        className="bar"
                                        style={{ height: `${height}%` }}
                                        title={`${months[item.mes - 1]}: $${item.total.toLocaleString()}`}
                                    ></div>
                                    <div className="bar-label">{months[item.mes - 1]}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {/* Partners por mes */}
            {partners_por_mes.length > 0 && (
                <div className="monthly-chart">
                    <h3>👥 Nuevos Partners por Mes (Año Actual)</h3>
                    <div className="chart-container">
                        {partners_por_mes.map((item, index) => {
                            const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
                                'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
                            const maxValue = Math.max(...partners_por_mes.map(p => p.cantidad));
                            const height = maxValue > 0 ? (item.cantidad / maxValue) * 100 : 0;

                            return (
                                <div key={index} className="chart-bar">
                                    <div
                                        className="bar bar--partners"
                                        style={{ height: `${height}%` }}
                                        title={`${months[item.mes - 1]}: ${item.cantidad} partners`}
                                    ></div>
                                    <div className="bar-label">{months[item.mes - 1]}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PartnerStatsAdmin;
